// extracted by mini-css-extract-plugin
module.exports = {"root":"SurveyList_root__3Vsbo","fullWidth":"SurveyList_fullWidth__3VH9h"};